import { IColumn } from "../../backend/transformers/datamodel-association-transformer";
import MultiTabComponent from "@/manager/components/multi-tab-component/multi-tab-component";
import DataTable from "@/manager/components/data-table/data-table";
import Page from "@/manager/components/page/page";

const columns: IColumn[] = [
  {
    key: "name",
    displayName: "Name",
    dataType: {
      type: "text",
    }
  }
];

const EnumerationList = () => {
  return <Page title={{
    text: "Lists",
    tooltip: "Create and manage lists. A list is a set of values that can be used for various purposes in the platform, such as defining options for a field or creating a translation list.",
  }}>
    <MultiTabComponent
      displayNextButton={false}
      enableHashRouting={true}
      tabs={[
        {
          key: "value-lists",
          name: "Value Lists",
          content: <DataTable
            defaultSortCol="name"
            columns={columns}
            dataUrl={{
              url: "datamodel/enumerations",
              backend: "platform"
            }}
            deleteUrl={{
              url: "datamodel/enumerations",
              backend: "platform"
            }}
            navigate_to="/lists/new"
            selectionMode="multi"
          />
        },
         {
          key: "translation-lists",
          name: "Translation Lists",
          content: <DataTable
            defaultSortCol="name"
            columns={columns}
            dataUrl={{
              url: "translation_list",
              backend: "platform"
            }}
            deleteUrl={{
              url: "translation_list",
              backend: "platform"
            }}
            navigate_to="/translation-lists/new"
            navigateToBaseUrl="/translation-lists"
            selectionMode="multi"
          />
        }
      ]}
    />
  </Page>
};

export default EnumerationList;
